// When an organisation's logo can be shown in a small square tile (the "Choose an organisation" list), and what to
// show instead. Used by the screens and the tests.

/** Wider than 4 : 1 or taller than 1 : 4 is too odd a shape to read in a small square: the initials are clearer. */
export const MAX_LOGO_RATIO = 4;

export function usableLogo(width: number, height: number): boolean {
  if (!(width > 0) || !(height > 0)) return false;
  const r = width / height;
  return r <= MAX_LOGO_RATIO && r >= 1 / MAX_LOGO_RATIO;
}

/** One or two letters for an organisation without a usable logo. */
export const orgInitials = (name: string) => name.trim().split(/\s+/).slice(0, 2).map((x) => x[0] || "").join("").toUpperCase() || "?";
